import IndexList from './indexlist.vue';
export default IndexList;
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('index-list', IndexList);
}



// WEBPACK FOOTER //
// ./src/index.js